export class InventoryTotal {
    id: number;
    valueInv: number;
    initial: number;
    scanned: number;
    procentage: number;
}